import React, { FC } from 'react';
import { GtmManager } from '../../utils/GtmManager';
import { HostProvider } from '../../utils/HostProvider';

interface Props {
  text: string;
  fromApp?: string;
  url?: string;
  title?: string;
  className?: string;
  openInNewWindow?: boolean;
}

const BlockLink: FC<Props> = ({ text, fromApp, url, title, className }) => {
  const clickLink = () => {
    if (url) {
      GtmManager.sendHeaderLinkClickGTM(url);
    }
  };
  const getHref = () => {
    if (fromApp === null || fromApp === undefined) {
      return url;
    }

    const baseUrl = HostProvider.isCaprabo()
      ? `${process.env.REACT_APP_API_CAPRABO}`
      : `${process.env.REACT_APP_API}`;
    return `${baseUrl}/clienteLogado/getTK?fromUrl=${url}&fromApp=${fromApp}`;
  };

  return (
    <>
      <div className={`block-link ${className}`}>
        <a
          href={getHref()}
          rel="noopener noreferrer"
          onClick={clickLink}
          title={title}
        >
          {text}
        </a>
      </div>
    </>
  );
};

export default BlockLink;
